import request from '@/utils/request';
import { membersEndpoint } from '@/constants/urls';
import memberEntities from './constants';
import UsersService from '../service';
import UserGroupsService from '../groups/service';

const entityMembers = (
  entity,
  entityCode,
  filter,
  assignableFlag,
) => {
  const params = { filter };

  if (assignableFlag) {
    params.assignable = true;
    params.page = 1;
    params.pageSize = 20;
  }

  return (
    request({
      url: membersEndpoint(entity, entityCode),
      params,
      method: 'GET',
    })
  );
};

const createEntityMember = (entity, entityCode, member) => {
  if (member.entity === memberEntities.USERGROUP) {
    return UserGroupsService.entityUserGroupsCreate(entity, entityCode, member.code)
      .then((response) => ({ ...response, action: 'new' }))
      .catch((error) => ({ ...member, action: 'new', error }));
  }
  return UsersService.entityCreate(entity, entityCode, member.uuid)
    .then((response) => ({ ...response, action: 'new' }))
    .catch((error) => ({ ...member, action: 'new', error }));
};

const deleteEntityMember = (entityType, entityCode, member) => {
  if (member.entity === memberEntities.USERGROUP) {
    return UserGroupsService.entityUserGroupsDestroy(entityType, entityCode, member.code)
      .then(() => ({ ...member, action: 'destroy' }))
      .catch((error) => ({ ...member, action: 'destroy', error }));
  }
  return UsersService.entityDestroy(entityType, entityCode, member.uuid)
    .then(() => ({ ...member, action: 'destroy' }))
    .catch((error) => ({ ...member, action: 'destroy', error }));
};

const updateEntityMember = (
  entityType,
  entityCode,
  member,
) => {
  if (member.entity === memberEntities.USERGROUP) {
    return UserGroupsService.entityUserGroupsUpdate(entityType, entityCode, member)
      .then((response) => ({ ...response, action: 'update' }))
      .catch((error) => ({ ...member, action: 'update', error }));
  }
  return UsersService.entityUpdate(entityType, entityCode, member)
    .then((response) => ({ ...response, action: 'update' }))
    .catch((error) => ({ ...member, action: 'update', error }));
};

const MembershipService = {
  entityMembers,
  createEntityMember,
  deleteEntityMember,
  updateEntityMember,
};

export default MembershipService;
